import { DefaultService } from '@/services/DefaultService';

export default class ColaboradorService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    save(cliente) {
        return this._http
            .post(`${this._env}/employees`, cliente, this._headers)
            .then((res) => res.body, this.handleError);
    }

    ativar(id) {
        return this._http
            .post(`${this._env}/employees/${id}`, null, this._headers)
            .then((res) => res.body, this.handleError);
    }
    delete(id) {
        return this._http
            .delete(`${this._env}/employees/${id}`, this._headers)
            .then((res) => res.body, this.handleError);
    }

    find(id) {
        return this._http
            .get(`${this._env}/employees/${id}.json`, this._headers)
            .then((res) => res.body, this.handleError);
    }

    findByErp(iderp) {
        return this._http
            .get(`${this._env}/employees/erp/${iderp}.json`, this._headers)
            .then((res) => res.body, this.handleError);
    }

    findAll(page = 0, limit = 50, sort, situacao = 2, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${this._env}/employees.json?page=${page}&limit=${limit}&column=${
                        sort.column
                    }&order=${sort.order}&situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then((res) => res.body, this.handleError);
    }

    findAllNotInRoute(page, limit, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/employees/not-in-route.json?page=${page}&limit=${limit}&param=${params}`
                ),
                this._headers
            )
            .then((res) => res.body, this.handleError);
    }

    findList(query) {
        return this._http
            .get(encodeURI(`${this._env}/employees/list.json?param=${query}`), this._headers)
            .then((res) => res.body, this.handleError);
    }

    findListAssociated(query, limit = 1000) {
        return this._http
            .get(
                `${this._env}/employees/list/associated.json?param=${query}&limit=${limit}`,
                this._headers
            )
            .then((res) => res.body, this.handleError);
    }

    findListAssociatedEmpresa(search, idempresa) {
        return this._http
            .get(
                `${
                    this._env
                }/employees/list/associacaoempresa.json?search=${search}&idempresa=${idempresa}`,
                this._headers
            )
            .then((res) => res.body, this.handleError);
    }

    findListAssociatedEmpresaFlex(search, idempresa) {
        return this._http.get(`${this._env}/employees/list/associacaoempresaflex.json?search=${search}&idempresa=${idempresa}`, this._headers)
                .then(res => res.body, this.handleError);
    }

    findListAssociatedIdsEmpresa(search, empresa) {
        return this._http
            .post(
                encodeURI(`${this._env}/employees/list/associacaoidsempresa.json?search=${search}`),
                empresa,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw err;
                }
            );
    }

    getClientes(page = 0, limit = 50, id, filters) {
        return this._http
            .post(
                `${this._env}/employees/${id}/clients.json?page=${page}&limit=${limit}`,
                filters,
                this._headers
            )
            .then((res) => res.body, this.handleError);
    }

    getClientesWithoutLimit(page = 0, id, filters) {
        return this._http
            .post(
                `${this._env}/employees/${id}/clientswithoutlimit.json?page=${page}`,
                filters,
                this._headers
            )
            .then((res) => res.body, this.handleError);
    }

    getClientesNoPagination(id, filters) {
        return this._http
            .post(`${this._env}/employees/${id}/allclients.json`, filters, this._headers)
            .then((res) => res.body, this.handleError);
    }
    
    findAllNaoAssociadosTurnoByEmpresa (idturno, idempresa, column = 'descricao', order='desc', page = 0, limit = 50, ...param) {
        return this._http.get(`${this._env}/sales/turno/colaborador/findAllNaoAssociadosTurnoByEmpresa/${idturno}.json?idempresa=${idempresa}&order=${order}&column=${column}&page=${page}&limit=${limit}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}
